import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user'])
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/nexts/resources/computed.js